<div class="bn-support">
  <a
    class="bn-support__link"
    routerLink="/support"
    routerLinkActive="bn-support__link--active">
    <fa-duotone-icon
      class="bn-support__icon"
      [icon]="['fad', 'life-ring']"
      [swapOpacity]="true" />Help & Support
    @if ((userDetails$ | async)?.UnreadSupportTicketCount) {
      <bn-web-ui-badge
        color="red"
        contentClass="bn-support__badge"
        size="xs"
        type="pill"
        >{{ (userDetails$ | async)?.UnreadSupportTicketCount }}</bn-web-ui-badge
      >
    }
  </a>
</div>
